<template>
  <div class="item">
    <div class="label">{{ label }} <span v-if="required" class="obligatory">*</span> <br /> {{ description }} </div>
    <select v-model="model" :class="{ error }">
      <option v-for="item in items" :key="item.key"  :value="item.key">
        {{ $t(item.value || item.name) }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SelectField',
  props: {
    value: String,
    label: String,
    description: String,
    required: Boolean,
    items: Array,
    error: Boolean
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" src="@/styles/_information.scss">
/* you can leave this empty or add component-specific overrides */
</style>
